import * as Types from '../../../../../graphql-types'

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type allOutletDiscountsQueryVariables = Types.Exact<{
  outletId: Types.Scalars['ID']
  fulfilmentMethod: Types.NarrowFulfilmentMethodInputType
}>

export type allOutletDiscountsQuery = {
  allDiscountsByOutletId: Array<{
    __typename: 'Discount'
    id: string
    name: string
    customerEnrolled: boolean
    discountAmount: number | null
    discountPercentage: number | null
    voucher: string | null
    minimumSubtotalGross: number | null
  }>
}

export const allOutletDiscountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allOutletDiscounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'outletId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fulfilmentMethod' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NarrowFulfilmentMethodInputType' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allDiscountsByOutletId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'outletId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'outletId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fulfilmentMethod' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fulfilmentMethod' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerEnrolled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountAmount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountPercentage' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'voucher' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'minimumSubtotalGross' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  allOutletDiscountsQuery,
  allOutletDiscountsQueryVariables
>
